export default "__VITE_ASSET__DFO$IJdi__"